// extracted by mini-css-extract-plugin
export default {"mainContainer":"RegisterSuccess_mainContainer__dTl48","contentContainer":"RegisterSuccess_contentContainer__Fs9bR","loginButton":"RegisterSuccess_loginButton__H4Px8"};